// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Box, Typography } from "@mui/material";
import Icon from "@mui/material/Icon";

import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

function Breadcrumbs({ icon, title, route: _route, light = false, darkMode = false }: any) {
  const breadcrumbs = useAppCustomStyles().widgets.breadcrumbs;
  const tone = { light, darkMode };
  const label = String(title || "").replace(/-/g, " ");

  return (
    <Box sx={breadcrumbs.container}>
      <Box sx={breadcrumbs.row} aria-label={label}>
        <Icon sx={breadcrumbs.icon(tone)}>{icon}</Icon>
        <Typography component="span" noWrap sx={breadcrumbs.label(tone)}>
          {label}
        </Typography>
      </Box>
    </Box>
  );
}

Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  light: PropTypes.bool,
  darkMode: PropTypes.bool,
};

export default Breadcrumbs;
